export default __webpack_public_path__ + "static/media/hht2_ep19_speaking_01.1892a1b0.png";